import React, { useCallback, useState } from 'react'
import SubGridTitle from './components/SubGridTitle'
import SubGrid from './components/SubGrid'
import { filter, isUndefined, size, upperCase } from 'lodash'
import { useTranslation } from 'react-i18next'
import {
  recalculateRowWithCompare,
  mapIdBtnToValueMatrix,
  addAccordionProperties
} from './utils'
import { DASGBOARDNOW_PAGE } from 'pages/Output/DashboardNowcasting/constants'
import './index.scss'

export const OvsGrid = (params) => {
  const { items, title, selectedItems, btnActiveId } = params
  const [data, setData] = useState(addAccordionProperties(items))
  const { t } = useTranslation('OutputView')

  const renderBody = useCallback(() => {
    let rowsToRender = filter(data, (el) => el.show || isUndefined(el?.show))

    if (btnActiveId !== 'none') {
      rowsToRender = rowsToRender.map((row) => {
        return recalculateRowWithCompare(row, btnActiveId)
      })
    }

    return (
      <>
        {rowsToRender.map((item) => {
          return (
            <div className='ovs-main-container'>
              <SubGridTitle
                t={t}
                config={{
                  id: item.name,
                  value: item?.name,
                  type: 'none',
                  accordion: item.accordion,
                  open: item.open,
                  bold: item?.bold,
                  fontSize: item?.fontSize
                }}
                data={data}
                setData={setData}
              />
              {item.value.map((val, idx) => {
                //mi dice l'indice del sottoblocco attivo del corrispettivo bottone cliccato
                const btnDiffValue = mapIdBtnToValueMatrix[btnActiveId]
                // true if compare is active and current block (pull,push,pushestremo) is not selected
                const comparingEnabled =
                  btnDiffValue !== -1 && idx !== btnDiffValue
                return (
                  <SubGrid
                    colNum={size(val)}
                    id={item.name}
                    items={val}
                    selectedItems={selectedItems}
                    comparingEnabled={comparingEnabled}
                  />
                )
              })}
            </div>
          )
        })}
      </>
    )
  }, [btnActiveId, data, selectedItems, t])

  return (
    <>
      <div className='ovs-main-container-title'>
        <h5>{t(`${DASGBOARDNOW_PAGE}.Section.${upperCase(title)}`)}</h5>
      </div>
      {renderBody()}
    </>
  )
}
export default OvsGrid
